import authHeader from './authHeader';
import AxiosService from './axiosService';
import appNotificationService from "@core/services/utils/appNotificationService";

class AppTranslationService {
  constructor() {
    this.store = null;
  }

  /**
   * Set the store instance (called from remote-app module)
   */
  setStore(store) {
    this.store = store;
  }

  /**
   * Get the store instance if available
   */
  getStoreInstance() {
    return this.store;
  }

  // ============================================
  // Methods for vue-i18n (flat key maps)
  // ============================================

  /**
   * Fetch translations for a specific lang as a flat map
   * Returns: { 'common.save': 'Save', 'common.cancel': 'Cancel', ... }
   */
  async fetchTranslations(lang) {
    try {
      const response = await AxiosService.post('/appTranslation/getTranslations', { lang: lang }, { headers: authHeader() });
      return response.data.translations;
    } catch (error) {
      console.error(`Failed to load translations for ${lang}:`, error);
      return null;
    }
  }

  /**
   * Fetch all translations grouped by lang as flat maps
   * Returns: { en: { 'common.save': 'Save', ... }, fr: { 'common.save': 'Sauvegarder', ... } }
   */
  async fetchAllTranslations() {
    try {
      const response = await AxiosService.post('/appTranslation/getTranslations', {}, { headers: authHeader() });
      return response.data.translations;
    } catch (error) {
      console.error('Failed to load translations:', error);
      return {};
    }
  }

  async getAllLangs() {
    try {
      const response = await AxiosService.post('/appTranslation/getAllLangs', {}, { headers: authHeader() });
      return response.data.langs;
    } catch (error) {
      console.error('Failed to load translations:', error);
      return {};
    }
  }


  // ============================================
  // Methods for admin UI (list of records)
  // ============================================

  /**
   * Load translations list from server (for admin grid)
   */
  async refresh() {
    try {
      let response = await AxiosService.get("/appTranslation/list", {
        headers: authHeader()
      });
      let appTranslations = response.data.translations;
      appTranslations.forEach((row, index) => {
        row.index = index;
      });
      if (this.store) {
        this.store.load(appTranslations);
      }
      return appTranslations;
    } catch (error) {
      appNotificationService.pushError(error);
    }
  }

  /**
   * Load translations list (for admin grid)
   */
  async list() {
    try {
      let response = await AxiosService.get("/appTranslation/list", {
        headers: authHeader()
      });
      let appTranslations = response.data.translations;
      appTranslations.forEach((row, index) => {
        row.index = index;
      });
      if (this.store) {
        this.store.load(appTranslations);
      }
      return appTranslations;
    } catch (error) {
      appNotificationService.pushError(error);
    }
  }

  /**
   * Add a new translation
   */
  async addOrUpdate(appTranslation) {
    try {
      let response = await AxiosService.post("/appTranslation/addOrUpdate", appTranslation, {
        headers: authHeader()
      });
      let updated = response.data.translation;
      if (this.store) {
        this.store.add(updated);
      }
      appNotificationService.pushInfo(response.data.message);
      return updated;
    } catch (error) {
      appNotificationService.pushError(error);
    }
  }

  /**
   * Delete a translation
   */
  async delete(appTranslation) {
    try {
      let response = await AxiosService.post("/appTranslation/delete", appTranslation, {
        headers: authHeader()
      });
      let updated = response.data.translation;
      if (this.store) {
        this.store.delete(updated);
      }
      appNotificationService.pushInfo(response.data.message);
      return updated;
    } catch (error) {
      appNotificationService.pushError(error);
    }
  }
}

// Create a single instance
const appTranslationService = new AppTranslationService();

// Export the instance
export default appTranslationService;
